import * as Yup from "yup";

export const InventoryFilterSchema = Yup.object().shape({
    warehouseIds: Yup.array()
        .required("Warehouse required!")
        .min(1, "Warehouse required!"),
});
